import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Aggiungi manager',
    first_name: {
      label: 'Nome',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Cognome',
      placeholder: 'White',
    },
    city: {
      label: 'Città',
      placeholder: 'Bonn',
    },
    email: {
      label: 'Email',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Ruolo',
      placeholder: 'Seleziona ruolo',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Titolare',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Reseller',
        [ManagerRole.SalesManager]: 'Responsabile vendite',
        [ManagerRole.SalesLeadership]: 'Responsabile lead vendite',
        [ManagerRole.ContentManager]: 'Responsabile contenuti',
        [ManagerRole.OnboardingManager]: 'Responsabile onboarding',
        [ManagerRole.MobileAppsManager]: 'Responsabile app mobile',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Dipendente',
        [ManagerRole.StoreOperator]: 'Operatore',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operatore:</strong> Accesso completo a Vendite, Menu, Top prodotti, Orari, Gift card, Prenotazioni e Report per le aziende assegnate.',
        [ManagerRole.StoreEmployee]: '<strong>Dipendente:</strong> Accesso limitato solo a Prenotazioni e Gift card.',
        [ManagerRole.StoreAdmin]:
          "<strong>Titolare:</strong> Accesso completo a un ristorante, inclusi storefront, impostazioni fiscali, marketing e gestione del team. Riceve un'email con le credenziali di accesso. Un solo titolare per ristorante, gli altri membri del team non possono modificarlo o rimuoverlo.",
      },
    },
    companies: {
      label: 'Aziende',
      placeholder: 'Seleziona aziende',
      owner_placeholder: 'Seleziona ristorante',
      has_owner: 'Ha un titolare',
    },
  },
  fields: {
    email: 'Email',
    name: 'Nome',
    roles: 'Ruolo',
    created_at: 'Creato',
    actions: 'Azioni',
    companies: 'Aziende',
    status: 'Stato',
  },
  tags: {
    owner: 'Titolare',
  },
  search: {
    placeholder: 'Cerca per nome o email',
  },
  buttons: {
    add_manager: 'Aggiungi manager',
    actions: 'Azioni',
    view_dashboard: 'Visualizza dashboard come questo manager',
    login_as_manager: 'Accedi come questo manager',
    delete: 'Elimina questo manager',
    resend_owner_invite: "Reinvia l'invito al titolare",
  },
  modals: {
    delete_manager: {
      title: 'Sei sicuro di voler eliminare il manager {{email}}?',
    },
    update_manager: {
      title: 'Sei sicuro di voler aggiornare il manager {{email}}?',
    },
    resend_owner_invite: {
      title: "Reinviare l'invito a {{email}}?",
      description: 'Il titolare riceve una nuova password via email. La password attuale smette di funzionare.',
    },
  },
  toasts: {
    successfully_created_manager: 'Manager creato con successo',
    owner_invited:
      '{{email}} è stato invitato come titolare del ristorante e riceverà le credenziali di accesso via email.',
    failed_to_load_data: 'Caricamento dati fallito, aggiorna la pagina',
    failed_to_create_manager: 'Creazione manager fallita',
    failed_to_create_magic_link: 'Creazione magic link fallita',
    failed_to_delete_manager: 'Eliminazione manager fallita',
    manager_got_deleted: 'Manager eliminato',
    successfully_updated_manager: 'Manager aggiornato',
    failed_to_update_manager: 'Aggiornamento manager fallito',
    owner_invite_resent: "L'invito è stato inviato di nuovo a {{email}}, con una nuova password.",
    owner_invite_resend_cooling_down:
      "L'invito è stato appena reinviato. Attendi qualche minuto prima di inviarlo di nuovo.",
    failed_to_resend_owner_invite: "Impossibile reinviare l'invito",
  },
};
